"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActions = getActions;
exports.getAll = getAll;
exports.getComments = getComments;
exports.getSegments = getSegments;
exports.postComment = postComment;
exports.updateAction = updateAction;
exports.updateActions = updateActions;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getAll(_ref) {
  var action = _ref.action,
      _ref$projectStatusId = _ref.projectStatusId,
      projectStatusId = _ref$projectStatusId === void 0 ? 1 : _ref$projectStatusId,
      teamId = _ref.teamId,
      sortBy = _ref.sortBy,
      sortOrder = _ref.sortOrder,
      projectId = _ref.projectId,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      priorityId = _ref.priorityId;

  var queryParams = _queryString["default"].stringify({
    action: action || undefined,
    teamId: teamId || undefined,
    projectId: projectId || undefined,
    priorityId: priorityId || undefined,
    sortBy: sortBy || 'created_at',
    sortOrder: sortOrder || 'desc',
    projectStatusId: projectStatusId,
    page: page
  });

  return _api["default"].get("/api/project-management?".concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getComments(id) {
  return _api["default"].get("/api/project-management/comments/".concat(id)).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateAction(_ref2) {
  var projectId = _ref2.projectId,
      priorityId = _ref2.priorityId,
      actionId = _ref2.actionId,
      extra1 = _ref2.extra1,
      extra2 = _ref2.extra2,
      extra3 = _ref2.extra3;
  return _api["default"].patch("/api/project-management/project/".concat(projectId), {
    priorityId: priorityId,
    actionId: actionId,
    extra1: extra1,
    extra2: extra2,
    extra3: extra3
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function postComment(projectId, comment) {
  return _api["default"].post("/api/note/project_management/".concat(projectId), {
    comment: comment
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getSegments(projectId) {
  return _api["default"].get("/api/project-management/segments/".concat(projectId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateActions(actions) {
  return _api["default"].post("/api/project-management/actions", actions).then(_api.extractData)["catch"](_api.errorHandler);
}

function getActions(actions) {
  return _api["default"].get("/api/project-management/actions", actions).then(_api.extractData)["catch"](_api.errorHandler);
}